export type TablaSubSection = {
  slug: string;
  title: string;
};

export type TablaSection = {
  slug: string;
  title: string;
  subSections: TablaSubSection[];
};

export const TABLA_SECTIONS: TablaSection[] = [
  {
    slug: "community",
    title: "Community",
    subSections: [
      { slug: "people", title: "People" },
      { slug: "events", title: "Events" },
      { slug: "opinion", title: "Opinion" },
    ],
  },
  {
    slug: "news",
    title: "News",
    subSections: [
      { slug: "singapore", title: "Singapore" },
      { slug: "india", title: "India" },
      { slug: "world", title: "World" },
    ],
  },
  {
    slug: "lifestyle",
    title: "Lifestyle",
    subSections: [
      // @note `/lifestyle/celebrity` returns 404 in stg
      { slug: "celebrity", title: "Celebrity" },
      { slug: "food", title: "Food" },
      { slug: "sports-fitness", title: "Sports & Fitness" },
    ],
  },
  {
    slug: "culture",
    title: "Culture",
    subSections: [
      { slug: "film", title: "Film" },
      { slug: "music", title: "Music" },
      { slug: "stage", title: "Stage" },
    ],
  },
];

export const TABLA_SECTION_PATHS: string[] = TABLA_SECTIONS.map(
  ({ slug }) => `/${slug}`,
);

export const TABLA_SUB_SECTION_PATHS: string[] = TABLA_SECTIONS.flatMap(
  ({ slug, subSections }) =>
    subSections.map(({ slug: subSectionSlug }) => `/${slug}/${subSectionSlug}`),
);

export const SectionToUniqueNameMapping: Record<string, string> = {
  community: "tabla_community",
  people: "tabla_community_people",
  events: "tabla_community_events",
  opinion: "tabla_community_opinion",
  news: "tabla_news",
  singapore: "tabla_news_singapore",
  india: "tabla_news_india",
  world: "tabla_news_world",
  lifestyle: "tabla_lifestyle",
  celebrity: "tabla_lifestyle_celebrity",
  food: "tabla_lifestyle_food",
  "sports-fitness": "tabla_lifestyle_sports-fitness",
  culture: "tabla_culture",
  film: "tabla_culture_film",
  music: "tabla_culture_music",
  stage: "tabla_culture_stage",
};
